module.exports = __webpack_public_path__ + "2183e65569a3a6395ff824cb01f554a4.png";